import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { alertActions, filterActions } from '_store';
import { history, fetchWrapper } from '_helpers';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
	return {
		// initialize state from local storage to enable user to stay logged in
		value: JSON.parse(localStorage.getItem('auth'))
	};
}

function createReducers() {
	return {
		setAuth
	};

	function setAuth(state, action) {
		state.value = action.payload;
	}
}

function createExtraActions() {
	const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}/auth`;

	return {
		login: login(),
		logout: logout()
	};

	function login() {
		return createAsyncThunk(
			`${name}/login`,
			async function ({ username, password }, { dispatch }) {
				dispatch(alertActions.clear());
				dispatch(filterActions.resetFilterOptions());
				try {
					const user = await fetchWrapper.post(`${baseUrl}/login`, { username, password });

					// set auth user in redux state
					dispatch(authActions.setAuth(user.data));

					// store user details and jwt token in local storage to keep user logged in between page refreshes
					localStorage.setItem('auth', JSON.stringify(user.data));

					// get return url from location state or default to home page
					const { from } = history.location.state || { from: { pathname: '/' } };
					history.navigate(from);
				} catch (error) {
					dispatch(alertActions.error(error));
				}
			}
		);
	}

	function logout() {
		return createAsyncThunk(
			`${name}/logout`,
			function (arg, { dispatch }) {
				dispatch(filterActions.resetFilterOptions());
				dispatch(authActions.setAuth(null));
				localStorage.removeItem('auth');
				history.navigate('/account/login');
			}
		);
	}
}